import { dialogEmits as K, dialogProps as L } from "./index642.js";
import { defineComponent as U, useSlots as x, computed as h, ref as f, provide as G, openBlock as k, createBlock as w, unref as e, withCtx as t, createVNode as v, Transition as H, mergeProps as R, withDirectives as J, createElementVNode as Q, normalizeStyle as W, normalizeClass as X, createSlots as Y, renderSlot as d, createCommentVNode as Z, vShow as _ } from "vue";
import { ElOverlay as ee } from "./index655.js";
import oe from "./index570.js";
import { ElTeleport as le } from "./index741.js";
import te from "./index742.js";
import { dialogInjectionKey as ae } from "./index638.js";
import { useDialog as se } from "./index637.js";
import { useDeprecated as re } from "./index664.js";
import { useNamespace as ne } from "./index559.js";
import { useSameTarget as ie } from "./index653.js";
const de = ["aria-label", "aria-labelledby", "aria-describedby"];
var we = /* @__PURE__ */ U({
  name: "ElDialog",
  inheritAttrs: !1,
  __name: "dialog",
  props: L,
  emits: K,
  setup(o, { expose: F }) {
    const i = o, $ = x();
    re(
      {
        scope: "el-dialog",
        from: "the title slot",
        replacement: "the header slot",
        version: "3.0.0",
        ref: "https://element-plus.org/en-US/component/dialog.html#slots"
      },
      h(() => !!$.title)
    );
    const a = ne("dialog"), g = f(), P = f(), c = f(), {
      visible: u,
      titleId: y,
      bodyId: p,
      style: T,
      overlayDialogStyle: A,
      rendered: b,
      transitionConfig: S,
      zIndex: E,
      _draggable: M,
      _alignCenter: I,
      _overflow: z,
      handleClose: m,
      onModalClick: D,
      onOpenAutoFocus: N,
      onCloseAutoFocus: q,
      onCloseRequested: B,
      onFocusoutPrevented: V,
      closing: O
    } = se(i, g);
    G(ae, {
      dialogRef: g,
      headerRef: P,
      bodyId: p,
      ns: a,
      rendered: b,
      style: T
    });
    const s = ie(D), j = h(
      () => i.modalPenetrable && !i.modal && !i.fullscreen
    );
    return F({
      /** @description whether the dialog is visible */
      visible: u,
      dialogContentRef: c,
      resetPosition: () => {
        var l;
        (l = c.value) == null || l.resetPosition();
      },
      handleClose: m
    }), (l, r) => (k(), w(e(le), {
      to: o.appendTo,
      disabled: o.appendTo !== "body" ? !1 : !o.appendToBody
    }, {
      default: t(() => [
        v(
          H,
          R(e(S), { persisted: "" }),
          {
            default: t(() => {
              var C;
              return [
                J(v(e(ee), {
                  "custom-mask-event": "",
                  mask: o.modal,
                  "overlay-class": [
                    (C = o.modalClass) != null ? C : "",
                    `${e(a).namespace.value}-modal-dialog`,
                    e(a).is("penetrable", j.value)
                  ],
                  "z-index": e(E)
                }, {
                  default: t(() => [
                    Q("div", {
                      role: "dialog",
                      "aria-modal": "true",
                      "aria-label": o.title || void 0,
                      "aria-labelledby": o.title ? void 0 : e(y),
                      "aria-describedby": e(p),
                      class: X([
                        `${e(a).namespace.value}-overlay-dialog`,
                        e(a).is("closing", e(O))
                      ]),
                      style: W(e(A)),
                      onClick: r[0] || (r[0] = //@ts-ignore
                      (...n) => e(s).onClick && e(s).onClick(...n)),
                      onMousedown: r[1] || (r[1] = //@ts-ignore
                      (...n) => e(s).onMousedown && e(s).onMousedown(...n)),
                      onMouseup: r[2] || (r[2] = //@ts-ignore
                      (...n) => e(s).onMouseup && e(s).onMouseup(...n))
                    }, [
                      v(e(oe), {
                        loop: "",
                        trapped: e(u),
                        "focus-start-el": "container",
                        onFocusAfterTrapped: e(N),
                        onFocusAfterReleased: e(q),
                        onFocusoutPrevented: e(V),
                        onReleaseRequested: e(B)
                      }, {
                        default: t(() => [
                          e(b) ? (k(), w(te, R({
                            key: 0,
                            ref_key: "dialogContentRef",
                            ref: c
                          }, l.$attrs, {
                            center: o.center,
                            "align-center": e(I),
                            "close-icon": o.closeIcon,
                            draggable: e(M),
                            overflow: e(z),
                            fullscreen: o.fullscreen,
                            "header-class": o.headerClass,
                            "body-class": o.bodyClass,
                            "footer-class": o.footerClass,
                            "show-close": o.showClose,
                            title: o.title,
                            "aria-level": o.headerAriaLevel,
                            onClose: e(m)
                          }), Y({
                            header: t(() => [
                              l.$slots.title ? d(l.$slots, "title", { key: 1 }) : d(l.$slots, "header", {
                                key: 0,
                                close: e(m),
                                titleId: e(y),
                                titleClass: e(a).e("title")
                              })
                            ]),
                            default: t(() => [
                              d(l.$slots, "default")
                            ]),
                            _: 2
                            /* DYNAMIC */
                          }, [
                            l.$slots.footer ? {
                              name: "footer",
                              fn: t(() => [
                                d(l.$slots, "footer")
                              ]),
                              key: "0"
                            } : void 0
                          ]), 1040, ["center", "align-center", "close-icon", "draggable", "overflow", "fullscreen", "header-class", "body-class", "footer-class", "show-close", "title", "aria-level", "onClose"])) : Z("v-if", !0)
                        ]),
                        _: 3
                        /* FORWARDED */
                      }, 8, ["trapped", "onFocusAfterTrapped", "onFocusAfterReleased", "onFocusoutPrevented", "onReleaseRequested"])
                    ], 46, de)
                  ]),
                  _: 3
                  /* FORWARDED */
                }, 8, ["mask", "overlay-class", "z-index"]), [
                  [_, e(u)]
                ])
              ];
            }),
            _: 3
            /* FORWARDED */
          },
          16
          /* FULL_PROPS */
        )
      ]),
      _: 3
      /* FORWARDED */
    }, 8, ["to", "disabled"]));
  }
});
export {
  we as default
};
